import React from 'react';
import { PageHeader } from '../components/common';
import { ROUTES } from '../constants';

const ProfilePage = () => {
  return (
    <div>
      <PageHeader
        title='My Profile'
        subtitle='Manage your account settings and preferences'
        breadcrumbs={[
          { name: 'Home', href: ROUTES.DASHBOARD },
          { name: 'Profile' },
        ]}
      />

      <div className='grid grid-cols-1 lg:grid-cols-3 gap-6'>
        {/* Profile Summary */}
        <div className='lg:col-span-1'>
          <div className='bg-white rounded-lg shadow-sm border border-gray-200'>
            <div className='p-6'>
              <div className='text-center'>
                <div className='mx-auto h-24 w-24 rounded-full bg-blue-500 flex items-center justify-center'>
                  <span className='text-2xl font-bold text-white'>JD</span>
                </div>
                <h3 className='mt-4 text-lg font-medium text-gray-900'>
                  John Doe
                </h3>
                <p className='text-sm text-gray-500'>john.doe@example.com</p>
                <div className='mt-4'>
                  <span className='inline-flex px-2 py-1 text-xs font-semibold rounded-full bg-purple-100 text-purple-800'>
                    Admin
                  </span>
                </div>
              </div>

              <div className='mt-6 border-t border-gray-200 pt-6'>
                <dl className='space-y-3'>
                  <div>
                    <dt className='text-sm font-medium text-gray-500'>
                      Member since
                    </dt>
                    <dd className='text-sm text-gray-900'>January 2023</dd>
                  </div>
                  <div>
                    <dt className='text-sm font-medium text-gray-500'>
                      Last login
                    </dt>
                    <dd className='text-sm text-gray-900'>2 hours ago</dd>
                  </div>
                  <div>
                    <dt className='text-sm font-medium text-gray-500'>
                      Status
                    </dt>
                    <dd className='text-sm text-green-600'>Active</dd>
                  </div>
                </dl>
              </div>
            </div>
          </div>

          {/* Quick Actions */}
          <div className='mt-6 bg-white rounded-lg shadow-sm border border-gray-200'>
            <div className='p-6'>
              <h4 className='text-lg font-medium text-gray-900 mb-4'>
                Quick Actions
              </h4>
              <div className='space-y-2'>
                <button className='w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-md'>
                  Change Password
                </button>
                <button className='w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-md'>
                  Enable Two-Factor Auth
                </button>
                <button className='w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-50 rounded-md'>
                  Download Data
                </button>
                <button className='w-full text-left px-3 py-2 text-sm text-red-600 hover:bg-red-50 rounded-md'>
                  Deactivate Account
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Profile Details */}
        <div className='lg:col-span-2 space-y-6'>
          {/* Personal Information */}
          <div className='bg-white rounded-lg shadow-sm border border-gray-200'>
            <div className='px-6 py-4 border-b border-gray-200'>
              <h3 className='text-lg font-medium text-gray-900'>
                Personal Information
              </h3>
            </div>
            <div className='p-6'>
              <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
                <div>
                  <label className='block text-sm font-medium text-gray-700 mb-1'>
                    First Name
                  </label>
                  <input
                    type='text'
                    defaultValue='John'
                    className='w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500'
                  />
                </div>
                <div>
                  <label className='block text-sm font-medium text-gray-700 mb-1'>
                    Last Name
                  </label>
                  <input
                    type='text'
                    defaultValue='Doe'
                    className='w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500'
                  />
                </div>
                <div>
                  <label className='block text-sm font-medium text-gray-700 mb-1'>
                    Email Address
                  </label>
                  <input
                    type='email'
                    defaultValue='john.doe@example.com'
                    className='w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500'
                  />
                </div>
                <div>
                  <label className='block text-sm font-medium text-gray-700 mb-1'>
                    Phone Number
                  </label>
                  <input
                    type='tel'
                    defaultValue='+1 (555) 123-4567'
                    className='w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500'
                  />
                </div>
                <div className='md:col-span-2'>
                  <label className='block text-sm font-medium text-gray-700 mb-1'>
                    Bio
                  </label>
                  <textarea
                    rows={3}
                    defaultValue='Experienced admin managing the SKAI1 platform...'
                    className='w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500'
                  />
                </div>
              </div>
              <div className='mt-6 flex justify-end'>
                <button className='bg-blue-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-blue-700'>
                  Save Changes
                </button>
              </div>
            </div>
          </div>

          {/* Security Settings */}
          <div className='bg-white rounded-lg shadow-sm border border-gray-200'>
            <div className='px-6 py-4 border-b border-gray-200'>
              <h3 className='text-lg font-medium text-gray-900'>
                Security Settings
              </h3>
            </div>
            <div className='p-6'>
              <div className='space-y-6'>
                <div className='flex items-center justify-between'>
                  <div>
                    <h4 className='text-sm font-medium text-gray-900'>
                      Two-Factor Authentication
                    </h4>
                    <p className='text-sm text-gray-500'>
                      Add an extra layer of security to your account
                    </p>
                  </div>
                  <button className='bg-green-600 text-white px-3 py-1 rounded-md text-sm font-medium hover:bg-green-700'>
                    Enable
                  </button>
                </div>

                <div className='flex items-center justify-between'>
                  <div>
                    <h4 className='text-sm font-medium text-gray-900'>
                      Login Notifications
                    </h4>
                    <p className='text-sm text-gray-500'>
                      Get notified when someone logs into your account
                    </p>
                  </div>
                  <div className='relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in'>
                    <input
                      type='checkbox'
                      name='toggle'
                      id='toggle'
                      className='toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer'
                    />
                    <label
                      htmlFor='toggle'
                      className='toggle-label block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer'
                    ></label>
                  </div>
                </div>

                <div className='flex items-center justify-between'>
                  <div>
                    <h4 className='text-sm font-medium text-gray-900'>
                      Session Timeout
                    </h4>
                    <p className='text-sm text-gray-500'>
                      Automatically log out after inactivity
                    </p>
                  </div>
                  <select className='px-3 py-1 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500'>
                    <option>30 minutes</option>
                    <option>1 hour</option>
                    <option>4 hours</option>
                    <option>Never</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          {/* Activity Log */}
          <div className='bg-white rounded-lg shadow-sm border border-gray-200'>
            <div className='px-6 py-4 border-b border-gray-200'>
              <h3 className='text-lg font-medium text-gray-900'>
                Recent Activity
              </h3>
            </div>
            <div className='p-6'>
              <div className='space-y-4'>
                {[
                  {
                    action: 'Logged in',
                    time: '2 hours ago',
                    ip: '192.168.1.1',
                  },
                  {
                    action: 'Updated profile',
                    time: '1 day ago',
                    ip: '192.168.1.1',
                  },
                  {
                    action: 'Changed password',
                    time: '3 days ago',
                    ip: '192.168.1.2',
                  },
                  {
                    action: 'Logged in',
                    time: '1 week ago',
                    ip: '192.168.1.1',
                  },
                ].map((activity, index) => (
                  <div
                    key={index}
                    className='flex items-center justify-between py-2'
                  >
                    <div>
                      <p className='text-sm font-medium text-gray-900'>
                        {activity.action}
                      </p>
                      <p className='text-xs text-gray-500'>IP: {activity.ip}</p>
                    </div>
                    <p className='text-sm text-gray-500'>{activity.time}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
